<template>
  <div class="home">
    <section class="hero is-fullheight">
      <div class="hero-body">
        <div class="container has-text-centered">
          <div class="column is-4 is-offset-4" v-if="!loading">
            <div class="box">
              <figure class="avatar">
                <img src="@/assets/logo-large.png" alt="BMI - Pricing Calculator" />
              </figure>
              <div class="login-content">
                <h1 class="login-content__title">{{$t("translation.title")}}</h1>
                <p>{{$t("translation.message")}}</p>
              </div>
              <a class="button is-primary is-large is-fullwidth is-outlined" :href="loginURL" v-if="loginURL">
                <span class="icon is-small">
                  <i class="icon ion-logo-google"></i>
                </span>
                <span>{{$t("translation.loginBtn")}}</span>
              </a>
              <div v-else>
                <article class="message is-danger">
                  <div class="message-body">
                    <strong>{{response.params.userEmail}}</strong>
                    <p>{{$t("translation.authError")}}</p>
                  </div>
                </article>
                <a class="button is-primary is-large is-fullwidth is-outlined"
                   :href="response.params.logoutURL">
                  <span class="icon is-small">
                    <i class="icon ion-logo-google"></i>
                  </span>
                  <span>{{$t("translation.logoutBtn")}}</span>
                </a>
              </div>
            </div>

            <languageSelector selectStyle="is-rounded" />

          </div>
          <div v-else>
            <loadingComponent :message="userMessage" />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import userStore from '@/store/userStore';
import loadingComponent from '@/components/loading.vue';
import languageSelector from '@/components/languageSelector.vue';

export default {
  title: 'Login • BMI Pricing Calculator',

  components: {
    loadingComponent,
    languageSelector,
  },

  data() {
    return {
      user: userStore.user,
      loginURL: '',
      response: {},
      loading: true,
      userMessage: '',
    };
  },

  watch: {
    $route: 'checkUserAuth',
  },

  mounted() {
    this.checkUserAuth();
  },

  i18n: {
    messages: {
      en: {
        translation: {
          title: 'BMI Pricing Calculator',
          message: 'Please login with you Google account in order to proceed.',
          authError: 'Sorry this account isn\'t authorised, please logout and try with another account.',
          loginBtn: 'Login with Google',
          logoutBtn: 'Logout',
        },
      },
      nor: {
        translation: {
          title: 'BMI-prisberegningskalkulator',
          message: 'Vennligst logg inn med Google-kontoen din for å fortsette',
          authError: 'Beklager, denne kontoen er ikke autorisert, vennligst logg ut og prøv med en annen konto',
          loginBtn: 'Logg inn med Google',
          logoutBtn: 'Logg ut',
        },
      },
    },
  },

  methods: {
    checkUserAuth() {
      if (!userStore.user.email) {
        fetch('/api/user/logged/in', {
          method: 'GET',
        }).then(res => res.json())
          .catch(() => {
            this.userMessage = 'Error loading the application, please refresh and try again.';
          })
          .then((response) => {
            this.response = response;
            if (response.status === 'UNAUTHORIZED') {
              this.loginURL = response.params.loginURL;
              this.loading = false;
            } else {
              userStore.user.email = response.email;
              userStore.user.admin = response.admin;
              userStore.response = response;
              this.$router.push({ path: this.$route.query.redirect });
            }
          });
      } else {
        this.$router.push({ name: 'calculator' });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.login-content {
  margin-bottom: 20px;

  &__title {
    font-size: 1.8em;
    font-weight: 300;
    border-bottom: 1px dotted #ccc;
    padding-bottom: 10px;
    margin-bottom: 10px;
  }
}

.box {
  margin-top: 5rem;
}
.avatar {
  margin-top: -70px;
  padding-bottom: 20px;
}
.avatar img {
  padding: 5px;
  background: #fff;
  border-radius: 50%;
  -webkit-box-shadow: 0 2px 3px rgba(10,10,10,.1), 0 0 0 1px rgba(10,10,10,.1);
  box-shadow: 0 2px 3px rgba(10,10,10,.1), 0 0 0 1px rgba(10,10,10,.1);
}

</style>
